import { IKnmReasonTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';

export const isAssignmentRequiredByType = (type: IKnmReasonTypeSelectOption | undefined) => {
  return (
    type?.assignmentNumberRequired || (type?.approveRequired && (type?.assignmentDateRequired || type?.dateRequired))
  );
};
